<template>
<div>
    <button type="button" class="open" aria-label="Open Debug" v-on:click="openPanel" v-bind:class="{hide:!isHidden}">
      <span aria-hidden="true">&plus; debug</span>
    </button>

<div class="debug-panel" v-bind:class="{hide:isHidden}">
    <button type="button" class="close" aria-label="Close" v-on:click="closePanel">
      <span aria-hidden="true">&times;</span>
    </button>
    <span v-html="htmlContent"></span>
</div>
</div>
</template>

<script>
export default {
    name: 'debugpanel',
    components: {
    },
    mounted: function() {
    },
    data() { 
        return {
            htmlContent: 'no data yet...',
            isHidden: true,
        }
    },
    methods: {
        setHtml(html) {
            this.htmlContent = html;
//            this.isHidden = false;
        },
        openPanel() {
            this.isHidden=false;
        },
        closePanel() {
            this.isHidden=true;
        }
    }

}
</script>

<style>
button.open{ 
position: absolute;
bottom:30px;
left:10px;
z-index:99;

}
.debug-panel.hide{ 
display:none !important;
}
.debug-panel {
font-size:95%;
line-height:0.98em;
opacity:0.80;
position:absolute;
bottom:0;
left:0px;
z-index:100;
min-height:140px;
padding:0.75em 0.75em 1.25em 0.75em;
margin:0;
width:95%;
background-color:#eeeeee;
border: 1px solid #909090;
}
.debug-panel button.close {
position:absolute;
right:10px;
margin-right:2em;

}
.debug-panel:hover {
     opacity:1;
}
.debug-panel h3 {
  margin-top:0.25em;
  margin-bottom:1.0em;
}
.debug-panel  h4, .debug-panel h5 {
  margin-top:0.25em;
  margin-bottom:0.25em;
}
.debug-panel p {
font-size:80%;
}
.debug-panel select {
  margin-bottom:1.25em;
}

</style>
